import i18n from 'infrastructure/i18n';
import EmailSuccessIcon from 'assets/img/icons/email-success.svg?react';

import s from './styles.module.scss';

import type { FC } from 'react';

const alreadyAnsweredTextMap = {
  text: {
    en: i18n.t('smsCampaign.alreadyAnsweredTextEng'),
    es: i18n.t('smsCampaign.alreadyAnsweredTextEsp'),
  },
  desc: {
    en: i18n.t('smsCampaign.alreadyAnsweredDescEng'),
    es: i18n.t('smsCampaign.alreadyAnsweredDescEsp'),
  },
} as const;

interface AlreadySentMessageProps {
  lang: 'en' | 'es';
}

const AlreadySentMessage: FC<AlreadySentMessageProps> = ({ lang }) => {
  return (
    <div className={s.wrapper}>
      <EmailSuccessIcon className={s.icon} />
      <p className={s.text}>{alreadyAnsweredTextMap.text[lang]}</p>
      <p className={s.desc}>{alreadyAnsweredTextMap.desc[lang]}</p>
    </div>
  );
};
export default AlreadySentMessage;
